<template>
	<div>
		<div class="text-center" v-if="loading>0"><b-icon icon="circle-fill" animation="throb" font-scale="4"></b-icon></div>
		<b-alert variant="danger" show v-else-if="error">{{error}}</b-alert>
		<b-table v-else small striped hover :items="services" :fields="['id', 'name', 'url', 'capabilities', { label: 'edit', key: 'edit', thClass: 'text-right', tdClass: 'text-right'}]">
			<template #head(edit)>
				<b-button @click="openEditModal()" variant="success" size="sm" v-b-tooltip.hover.left.v-success title="Add a service"><b-icon icon="plus"></b-icon></b-button>
			</template>
			<template #cell(id)="data">
				<b-form-checkbox switch v-model="data.item.status" value="enabled" unchecked-value="disabled" @change="setServiceStatus(data.item.id, data.item.status)"/>
				<code>{{data.item.id}}</code><br />
			</template>
			<template #cell(name)="data">
				<b-avatar :src="data.item.icon?.url" size="1rem"></b-avatar>
				<router-link :to="{ name: 'Service', params: { id: data.item.id } }">{{data.item.name}}</router-link><br />
				<small>{{data.item.protocol_name}}</small>
			</template>
			<template #cell(capabilities)="data">
				{{data.value.join(', ')}}
			</template>
			<template #cell(edit)="data">
				<b-button-group size="sm">
					<b-button @click="openEditModal(data.item.id)" v-b-tooltip.hover.left title="Edit service"><b-icon icon="pencil-fill"></b-icon></b-button>
					<b-button @click="openDeleteModal(data.item.id)" variant="danger" v-b-tooltip.hover.right.v-danger title="Delete service"><b-icon icon="trash"></b-icon></b-button>
				</b-button-group>
			</template>
		</b-table>
		<service-edit-modal ref="edit-modal" @saved="loadServices"></service-edit-modal>
		<service-delete-modal ref="delete-modal" @deleted="loadServices"></service-delete-modal>
	</div>
</template>

<script>
import ServiceEditModal from './Modal/Edit.vue';
import ServiceDeleteModal from './Modal/Delete.vue';

export default {
	name: 'ServiceList',
	data() { return {
		services: [],
		loading: false,
		error: null,
	}},
	components: {
		ServiceEditModal,
		ServiceDeleteModal
	},
	created() {
		this.loadServices();
	},
	methods: {
		async loadServices() {
			try {
				this.loading++;
				this.error = null;
				this.services = await this.$api.get('admin/services')
			} catch(err) {
				this.error = err.error || err.toString();
			} finally {
				this.loading--;
			}
		},
		openEditModal(id) {
			this.$refs['edit-modal'].show(id);
		},
		openDeleteModal(id) {
			this.$refs['delete-modal'].show(id);
		},
		async setServiceStatus(id, status) {
			try {
				this.loading++;
				this.error = null;
				await this.$api.post(`admin/service/${encodeURIComponent(id)}/status`, { status });
			} catch(e) {
				this.error = e;
			} finally {
				this.loading--;
			}
		},
	}
};
</script>
